<template>
	<div class="wrapper1200" style="display: flex;margin-top: 20px;">
		<div class="classification">
			<div class="singleType" :class="typeIndex==0?'active':''" @click="jumpTo">病例信息</div>
			<div class="singleType" :class="typeIndex==1?'active':''" @click="jumpTo">历史病例</div>
		</div>
		<div class="diagnosis">
			<div class="heartache">
				<div>病例信息</div>
				<div>></div>
				<div>历史病例</div>
				<div> ></div>
				<div>添加病例</div>
			</div>
			<div class="addTo">
				<div class="title">添加病例</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">就诊号</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入就诊号" v-model="no" />
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">就诊时间</div>
						<div class="inputBox">
							<el-date-picker v-model="caseTime" type="date" placeholder="选择日期" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</div>
					</div>
				</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">科室</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入科室" v-model="subject" />
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">身高(cm)</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入身高" v-model="height" />
						</div>
					</div>
				</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">体重(kg)</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入体重" v-model="weight" />
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">辅助检查</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入辅助检查" v-model="assist" />
						</div>
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">主诉</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入主诉内容" v-model="suit" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">现病史</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入现病史内容" v-model="historyOfPresentIllness" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">既往史和其他病史</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入既往史和其他病史内容" v-model="medicalHistory" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">过敏史(食物或者药品)</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入过敏史(食物或者药品)内容" v-model="allergy" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">诊断</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入诊断内容" v-model="diagnose" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">处理</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入处理内容" v-model="dispose" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">病情评估</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入病情评估内容" v-model="assess" />
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">治疗意见</div>
					<div class="chiefComplaintInput">
						<input type="text" placeholder="请输入治疗意见内容" v-model="opinion" />
					</div>
				</div>
				<div class="caseImages">
					<div class="titleImage">上传病例图片</div>
					<div class="uploadImage">
						<!-- <div style="display: flex;align-items: center;">
							<img :src="item" alt="" v-if="img.length!=0" v-for="(item,index) in img" :key="index" />
						</div> -->
						<el-upload class="avatar-uploader" ref="lEmblemFace" :action="action" :show-file-list="true"
							:limit='1' list-type="picture-card" :on-success="uploadFilenationalEmblemFace"
							:on-remove="handleRemovenationalEmblemFace"
							style="width: 42.5px;height: 42.5px;display: flex;" :headers="{token: token}">
							<img src="../assets/icon/uploadImage.png" alt="" />
						</el-upload>
						<!-- <img src="../assets/icon/uploadImage.png" alt="" /> -->
					</div>
				</div>
				<div class="saveButton" @click="preservation">保存</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		newlyAddedCases
	} from "@/api/api.js"
	import {
		baseURL
	} from "@/api/index";
	export default {
		data() {
			return {
				action: baseURL + "/common/upload",
				token: localStorage.getItem('token'),
				typeIndex: 1,
				no: "",
				caseTime: '',
				subject: '',
				height: '',
				weight: '',
				assist: '',
				suit: '',
				historyOfPresentIllness: '',
				medicalHistory: '',
				allergy: '',
				diagnose: '',
				dispose: '',
				assess: '',
				opinion: '',
				img: ''
			}
		},
		methods: {
			//添加保存
			preservation() {
				if (this.no == '') {
					this.$message.error('请输入就诊号')
					return
				}
				if (this.caseTime == '') {
					this.$message.error('请选择就诊时间')
					return
				}
				if (this.subject == '') {
					this.$message.error('请输入科室')
					return
				}
				if (this.height == '') {
					this.$message.error('请输入身高')
					return
				}
				if (this.weight == '') {
					this.$message.error('请输入体重')
					return
				}
				if (this.assist == '') {
					this.$message.error('请输入辅助检查')
					return
				}
				if (this.suit == '') {
					this.$message.error('请输入主诉内容')
					return
				}
				if (this.historyOfPresentIllness == '') {
					this.$message.error('请输入现病史')
					return
				}
				if (this.medicalHistory == '') {
					this.$message.error('请输入过敏史(食物或者药品)')
					return
				}
				if (this.diagnose == '') {
					this.$message.error('请输入诊断')
					return
				}
				if (this.dispose == '') {
					this.$message.error('请输入处理')
					return
				}
				if (this.assess == '') {
					this.$message.error('请输入病情评估')
					return
				}
				if (this.opinion == '') {
					this.$message.error('请输入治疗意见')
					return
				}
				if (this.img == '') {
					this.$message.error('请上传病例图片')
					return
				}
				newlyAddedCases({
					no: this.no,
					caseTime: this.caseTime,
					subject: this.subject,
					height: this.height,
					weight: this.weight,
					assist: this.assist,
					suit: this.suit,
					historyOfPresentIllness: this.historyOfPresentIllness,
					medicalHistory: this.medicalHistory,
					allergy: this.allergy,
					diagnose: this.diagnose,
					dispose: this.dispose,
					assess: this.assess,
					opinion: this.opinion,
					img: this.img,
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({
								path: '/caseInformation'
							})
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			uploadFilenationalEmblemFace(res, fileList) {
				console.log(res)
				this.img = res.url
				this.$refs.lEmblemFace.$children[1].$el.style.display = 'none'
			},
			handleRemovenationalEmblemFace(file, fileList) {
				this.img = ''
				this.$refs.lEmblemFace.$children[1].$el.style.display = ''
			},
			jumpTo() {
				this.$router.push({
					path: '/caseInformation'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-upload-list__item-status-label {
		display: none !important;
	}

	::v-deep .el-upload-list--picture-card {
		display: flex;
		width: 330px;
	}

	::v-deep .el-upload--picture-card {
		width: 42.5px;
		height: 42.5px;
		line-height: normal;
		border: none;
	}

	::v-deep .el-upload-list--picture-card .el-upload-list__item {
		width: 42.5px;
		height: 42.5px;
	}

	.classification {
		.singleType {
			width: 202px;
			height: 50px;
			background: #F1F1F1;
			border-radius: 0px 0px 0px 0px;
			line-height: 50px;
			padding-left: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
		}

		.active {
			background: #D89A3A;
			color: #fff;
		}
	}

	.diagnosis {
		margin-left: 20px;
		padding-bottom: 132px;
		// position: relative;
		flex: 1;
		cursor: default;

		.heartache {
			display: flex;
			align-items: center;

			div {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
				margin-right: 10px;
			}




		}

	}

	.addTo {
		background: #FFFFFF;
		padding: 30px 100px;
		margin-top: 20px;

		.title {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: bold;
			font-size: 22px;
			color: #333333;
			text-align: center;
			margin-bottom: 30px;
		}

		.howManyInARow {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.single {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #E6E6E6;
				padding: 15px 0;
				width: 45%;

				.medicalConsultation {
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					// width: 56px;
				}

				.inputBox {
					border: none;
					outline: none;
					box-shadow: none;
					margin-left: 40px;

					input {
						border: none;
						outline: none;
						box-shadow: none;
					}
				}
			}
		}

	}

	.indiChiefComplaint {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #E6E6E6;
		padding: 15px 0;

		.vidual {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #333333;
		}

		.chiefComplaintInput {
			margin-left: 54px;
			flex: 1;

			input {
				width: 100%;
				border: none;
				outline: none;
				box-shadow: none;
			}
		}
	}

	.caseImages {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px 0;
		border-bottom: 1px solid #E6E6E6;

		.titleImage {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
		}

		.uploadImage {
			// flex: 1;
			// margin-left: 40px;

			img {
				width: 42.5px;
				height: 42.5px;
			}
		}

	}

	.saveButton {
		width: 661px;
		height: 50px;
		background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
		border-radius: 30px 30px 30px 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		line-height: 50px;
		margin: 0 auto;
		margin-top: 60px;
	}
</style>